import { createViewerCreditsSlot } from '@coosmo/shared-utils/tenant-assets-service'

let creditsSlotController = null
let defaultVisibility = false

function isVisibleByDefault(assets) {
  return assets.defaultAsset === 'credits' && assets.tenantName !== 'haltadefinizione'
}

export function mountViewerCreditsSlot({ target, assets, largeIcons, viewerId }) {
  creditsSlotController?.destroy()
  defaultVisibility = isVisibleByDefault(assets)
  creditsSlotController = createViewerCreditsSlot({
    target,
    assets,
    visible: defaultVisibility,
    interactive: !largeIcons,
    attributes: {
      root: {
        id: 'logoContainer',
        class: largeIcons ? 'logoContainerLarge' : ''
      },
      image: {
        id: `logoImg${viewerId}`
      }
    }
  })

  return creditsSlotController
}

export function setViewerCreditsVisibility(visible) {
  creditsSlotController?.setVisible(visible)
}

export function restoreViewerCreditsVisibility() {
  setViewerCreditsVisibility(defaultVisibility)
}
